<template>
  <div>
    <iframe :src="url" class="admin-frame"></iframe>
  </div>
</template>

<script>
  import { API_URL } from '@/config/config';

  export default {
    data() {
      return {
        url: `${API_URL}/admin`
      }
    }
  }
</script>

<style scoped>
  .admin-frame {
    width: 100%;
    height: 90vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/modules/general/Admin.vue